export enum AppointmentDisplayState {
    UPCOMING = 'upcoming',
    PAST = 'past',
    CANCELLED = 'cancelled',
}
